import React from 'react';

interface CtaCustomizingStyleContainerProps {
    readonly children?: React.ReactNode;
}

export const CtaCustomizingStyleContainer: React.FC<CtaCustomizingStyleContainerProps> = ({
    children
}) => <div className="grid gap-4">{children}</div>;
